<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-enter`]" width="1em" height="1em" v-bind="$attrs"><path d="M13.2549 3.1875C13.6221 3.18761 13.9199 3.48534 13.9199 3.85254V4.37109C13.9199 5.2001 13.9205 5.86193 13.877 6.39551C13.8327 6.93685 13.7397 7.40475 13.5205 7.83496C13.1692 8.52446 12.6084 9.08514 11.9189 9.43652C11.4888 9.65571 11.0208 9.74873 10.4795 9.79297C9.94596 9.83656 9.28399 9.83594 8.45508 9.83594H4.34961L6.1875 11.6729C6.44701 11.9326 6.44714 12.3546 6.1875 12.6143C5.9279 12.8734 5.50666 12.8734 5.24707 12.6143L2.27441 9.6416L2.19141 9.54004C2.1193 9.43176 2.08014 9.30291 2.08008 9.1709C2.08019 8.99488 2.15007 8.82574 2.27441 8.70117L5.24707 5.72852C5.50671 5.46904 5.92784 5.46908 6.1875 5.72852C6.44696 5.98818 6.44698 6.4093 6.1875 6.66895L4.35156 8.50586H8.45508C9.30592 8.50586 9.90427 8.50591 10.3711 8.46777C10.8298 8.43028 11.103 8.35958 11.3145 8.25195C11.7537 8.02815 12.1111 7.67062 12.335 7.23145C12.4427 7.01995 12.5133 6.74622 12.5508 6.28711C12.5889 5.82025 12.5898 5.22201 12.5898 4.37109V3.85254C12.5898 3.48527 12.8876 3.1875 13.2549 3.1875Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineEnter',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
